export const HUBSPOT_CONTACT_DETAILS_FORM_ID = "c4fb7737-968f-4f13-bff4-ac22ab0d7ab4";
export const HUBSPOT_USER_DETAILS_FORM_ID = "c8c49158-4926-475d-bfb0-185fbb34076f";
